import { put, takeLatest, select, all } from 'redux-saga/effects'

import { getConfig } from '@tabeeb/modules/appConfigState/selectors'
import { onAddInfoNotification, onAddErrorNotification } from '@tabeeb/modules/notification/actions'

import { ErrorCode } from '@tabeeb/enums'
import * as aiActions from '../actions'
import * as tenantConfigActions from '../../tenantConfigPage/actions'
import { removeTemporaryFields } from '../../tenantConfigPage/services/configHelpers'

function* onDeleteModelSuccess() {
  yield put(onAddInfoNotification({ message: 'Model was successfully deleted' }))
}

function getDeleteFailedErrorMessage(Error) {
  switch (Error.Code) {
    case ErrorCode.NoDeletePredictionSetIfAIModelShared:
      return `It's not allowed to delete a model if it's published to other tenants.`
    case ErrorCode.NoDeletePredictionSetIfAIModelUsedInAIExpressions:
      return `It's not allowed to delete a model if it's used in AI Expressions.`
    default:
      return 'Failed to delete a model'
  }
}

function* onDeleteModelFailed(action, payload) {
  const message = getDeleteFailedErrorMessage(action.response.data.Error)
  yield put(onAddErrorNotification({ message }))
}

function* onDeletePredictionSetSuccess() {
  yield onDeleteModelSuccess()

  const predictionSets = yield select((state) => state.artificialIntelligence.predictionSets)
  const appConfigState = yield select(getConfig)

  if (predictionSets.length <= 0) {
    const newConfig = { ...appConfigState, isDetectObjects: false }
    removeTemporaryFields(newConfig)
    yield put(tenantConfigActions.updateConfig.request({ subdomain: newConfig.subdomain, config: newConfig }))
  }
}

function* deleteModel() {
  yield all([
    takeLatest(
      [aiActions.deleteNlpModel.failed, aiActions.deleteVqaModel.failed, aiActions.deletePredictionSet.failed],
      onDeleteModelFailed
    ),
    takeLatest([aiActions.deleteNlpModel.success, aiActions.deleteVqaModel.success], onDeleteModelSuccess),
    takeLatest(aiActions.deletePredictionSet.success, onDeletePredictionSetSuccess),
  ])
}

export default deleteModel
